import "./Teachers.css";
import React from "react";
import { MoonLoader } from "react-spinners";
import { BaseURL } from "../../Hooks/URL";
import TextFieldInput from "../../Components/Atoms/Inputs/TextField/TextFieldInput";
import { images } from "../../Assets/assetsHelper";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import Filter from "../../Components/Molecules/Filter/Filter";
import { Pagination } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import AddIcon from "@mui/icons-material/Add";
import MaleIcon from "@mui/icons-material/Male";
import FemaleIcon from "@mui/icons-material/Female";
import SchoolIcon from "@mui/icons-material/School";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import SortButton from "../../Components/Molecules/SortButton/SortButton";

function Teachers({
  role,
  page,
  searchData,
  search,
  setSearchData,
  setSearch,
  teachers,
  navigate,
  handleChangePage,
  loading,
  pageCount,
  setFilter,
  totalCount,
  setSort,
  currentSort,
}) {
  // if (loading) {
  //   return (
  //     <div className="mainContainer">
  // <div className="loadingContainer">
  //   <MoonLoader color="#012369" size={40} />
  // </div>
  //     </div>
  //   );
  // }

  return (
    <div className="mainContainer">
      {/* Page Header */}
      <div className="pageHeader">
        <div className="pageTitle">
          <div className="titleIcon">
            <PersonIcon />
          </div>
          <div className="titleContent">
            <h1>Instructors Management</h1>
            <p>Manage and view all registered instructors</p>
          </div>
        </div>

        <button
          className="actionButton primary addButton"
          onClick={() => navigate("/instructors/add")}
        >
          <AddIcon />
          Add Instructor
        </button>
      </div>

      {loading ? (
        ""
      ) : (
        <>
          {/* Statistics Cards */}
          <div className="statsGrid">
            <div className="statCard">
              <div className="statIcon primary">
                <PersonIcon />
              </div>
              <div className="statContent">
                <h4>Total Instructors</h4>
                <h2>{totalCount || 0}</h2>
              </div>
            </div>
            <div className="statCard">
              <div className="statIcon success">
                <CheckCircleIcon />
              </div>
              <div className="statContent">
                <h4>Active Instructors</h4>
                <h2>
                  {teachers?.filter((teacher) => teacher.active).length || 0}
                </h2>
              </div>
            </div>
            <div className="statCard">
              <div className="statIcon warning">
                <CancelIcon />
              </div>
              <div className="statContent">
                <h4>Pending Instructors</h4>
                <h2>
                  {teachers?.filter((teacher) => !teacher.active).length || 0}
                </h2>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Instructors Cards */}
      <div className="contentSection">
        <div className="tableHeader">
          <h2 className="sectionTitle">Instructors List</h2>
        </div>

        <div className="searchFilterHeader">
          <div className="searchFilterGroup">
            <TextFieldInput
              searchIcon={true}
              Required={false}
              type="text"
              placeholder={"Search instructors..."}
              className="modernSearchBar"
              name={"search"}
              change={(e) => setSearchData(e.target.value)}
              newValue={searchData}
              searchAction={() => {
                if (search !== searchData) {
                  setSearch(searchData);
                }
              }}
              keyDown={(e) => {
                if (e.keyCode === 13) {
                  if (search !== searchData) {
                    setSearch(searchData);
                  }
                }
              }}
            />
            <Filter Gender schools activated setFilter={setFilter} />
            <SortButton
              setSort={setSort}
              currentSort={currentSort}
              name
              createdAt
            />
          </div>
        </div>

        {loading ? (
          ""
        ) : (
          <>
            <div className="tableHeaderCount">
              <div className="tableActions">
                <span className="resultsCount">
                  Showing {teachers?.length || 0} instructors
                </span>
              </div>
            </div>
          </>
        )}

        {loading ? (
          <div className="loadingContainer">
            <MoonLoader color="#012369" size={40} />
          </div>
        ) : (
          <>
            {teachers && teachers.length > 0 ? (
              <div className="teachersGrid">
                {teachers.map((teacher) => (
                  <div
                    key={teacher.id}
                    className="teacherCard"
                    onClick={() => navigate(`/instructors/${teacher.id}`)}
                  >
                    {/* Status Indicator in Top Corner */}
                    <div
                      className={`statusIndicatorTopRight ${
                        teacher?.active ? "active" : "inactive"
                      }`}
                    >
                      {teacher?.active ? <CheckCircleIcon /> : <CancelIcon />}
                      {/* {teacher?.active ? "Active" : "Inactive"} */}
                    </div>

                    <div className="teacherAvatar">
                      {teacher?.photoFilePath ? (
                        <img
                          alt="teacher photo"
                          src={`${BaseURL}/${teacher?.photoFilePath}`}
                          className="teacherPhoto"
                        />
                      ) : (
                        <div className="teacherLogoPlaceholderSmall">
                          <PersonIcon style={{ fontSize: "48px" }} />
                        </div>
                      )}
                    </div>

                    <div className="teacherInfo">
                      <h3 className="teacherNameSmall">{teacher?.name}</h3>
                      <p className="teacherEmail">{teacher?.email}</p>

                      <div className="teacherDetails">
                        {/* <div className="detailItem">
                      <span className="detailLabel">Gender:</span>
                      <span className="detailValue">
                        {teacher?.gender == "male" ? (
                          <>
                            <MaleIcon className="genderIcon male" />
                            Male
                          </>
                        ) : (
                          <>
                            <FemaleIcon className="genderIcon female" />
                            Female
                          </>
                        )}
                      </span>
                    </div> */}

                        <div className="detailItem">
                          <span className="detailLabel">Phone:</span>
                          <span className="detailValue">
                            {teacher?.phone || "N/A"}
                          </span>
                        </div>

                        {role === "admin" && (
                          <div className="detailItem">
                            <span className="detailLabel">School:</span>
                            <span className="detailValue">
                              <SchoolIcon className="schoolIcon" />
                              {teacher?.school?.name ?? "Skill Code"}
                            </span>
                          </div>
                        )}

                        <div className="detailItem">
                          <span className="detailLabel">National ID:</span>
                          <span className="detailValue">
                            {teacher?.nationalId || "N/A"}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="emptyState">
                <div className="emptyIcon">
                  <PersonIcon />
                </div>
                <h3>No Instructors Found</h3>
                <p>
                  No instructors have been added yet. Start by adding your first
                  instructor.
                </p>
                <button
                  className="actionButton primary"
                  onClick={() => navigate("/instructors/add")}
                  style={{ margin: "20px auto" }}
                >
                  <AddIcon />
                  Add First Instructor
                </button>
              </div>
            )}
          </>
        )}

        {loading ? (
          ""
        ) : (
          <>
            {/* Pagination */}
            {teachers && teachers.length > 0 && (
              <div className="paginationContainer">
                <Pagination
                  count={pageCount}
                  page={page + 1}
                  onChange={handleChangePage}
                  size="large"
                  color="primary"
                  className="paginationCount"
                />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default Teachers;
